<template>
  <div class="content-center">


    <div class="md:basis-1/2 p-2">
      <div class="lg:max-w-[500px] mx-auto">
        <h2 class="mb-4 font-bold text-2xl">Reset Password</h2>
        <V-Form
            @submit="reset"
            :validation-schema="schemaLogin"
        >
          <div class="flex flex-col">
            <div class="mb-4">
              <front-field label="E-mail*:">
                <front-control
                    v-model="email"
                    type="text"
                    name="email"
                />
              </front-field>
            </div>
            <div class="mb-4">
              <front-field label=" ">
                <front-jb-button
                    label="Reset Password"
                    color="darkred"
                    class="rounded-r-none min-w-[200px]"
                    type="submit"
                />
              </front-field>
            </div>
          </div>
        </V-Form>
      </div>
    </div>
  </div>
</template>
<script setup>
import * as Yup from "yup";
import {computed, ref} from "vue";
import {http} from "~/utils/http";
import Swal from "sweetalert2";
import {useHead} from "nuxt/app";
import {useSiteTitle} from "../../composables/state";

const schemaLogin = Yup.object().shape({
  'email': Yup.string().trim().required().nullable().label('Email'),
});

const email = ref('');
const siteTitle = useSiteTitle();

useHead({
  title: computed(() => 'Reset Password - ' + siteTitle.value) ,
  meta: [
    {name: 'description', content: computed(() => siteTitle.value)},
    {name: 'keywords', content: computed(() =>siteTitle.value)},
    { property: 'og:title', content: computed(() =>'Reset Password - ' +siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() =>siteTitle.value) },
    { property: 'og:url', content:computed(() =>siteTitle.value) },
  ],
})

const reset = async () => {
  try {
    await http.post('/api/reset-pass', {email:email.value}).then((response) => {
      Swal.fire({
        icon: 'success',
        title: 'Reset Password',
        text: response.data?.message,
      })
    });
  } catch (e) {
    if (e.response?.data?.errors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: e.response.data.errors?.email[0],
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      })
    }
  }

}
</script>
